import 'css-chunk:src/app/components/ApplicationPageTemplates/QuickTemplate/Perks/Perks.scss';export default {
  "Perks": "_Perks_yegfc_1",
  "group": "_group_yegfc_1",
  "perk": "_perk_yegfc_4",
  "text": "_text_yegfc_10"
};